




























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Form } from 'wok-forms';

@Component
export default class PasswordRecovery extends Vue {
    @Prop() signinRoute: any;
    @Prop() updateLinkPrefix: string;
    @Prop() bannerSrc: any;

    submitEnabled = false;
    emailSubmitted = false;
    email = "";

    get isMobile() {
        return this.$store.state.isMobile;
    }

    onEmailValidChange(valid: boolean) {
        this.submitEnabled = valid;
    }

    async onSubmit() {
        this.submitEnabled = false;
        await this.$store.dispatch('passwordSendUpdateEmail', { username: this.email, linkPrefix: this.updateLinkPrefix });
        this.submitEnabled = true;
        this.emailSubmitted = true;
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/dndg/access/password-recovery.vue